import React, { useEffect, useState } from 'react'
import Header from '../../component/Header';
import { Link } from 'react-router-dom';


export default function Corporate(props) {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Header />
            <section className='banner-section-about top bottom p-l-r'>
                <div className='about-banner-content about-banner-content_new'>
                    {/* <img src={require('../../assets/images/frame1.png')} /> */}
                    <h1 className='about-page-heading'>
                        Improving employee wellness, as experiences of life become the lessons of life.</h1>
                    <p className='paragraph paragraph-font'>Corporate Subscription with Us would provide you with access to wellness content, an opportunity to become a podcaster and book a Talk to me session with our wellness experts</p>

                    <div className='banner-img-page'>
                        <img src={require('../../assets/images/3-min.png')} />
                    </div>

                    <p className='paragraph'>We also offer optional offsite experiences to complement our app in addition to a few online sessions as well to follow up. This would help in maximizing employee engagement and retention.</p>

                </div>
            </section>
            <section className='workplace-issues bottom top p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div class="col-lg-12">
                            <div class="mental-health-content">
                                <h3 class="heading2 text_gradient_2">
                                    Workplace Issues <br />We are facing Today
                                </h3>
                            </div>
                        </div>
                        <div className='col-12'>
                            <ul>
                                <li>
                                    <img src={require('../../assets/images/frame2.png')} />
                                    <h3>41%</h3>
                                    <p>Of employees globally say that they experince significant stress during their workday.</p>
                                </li>
                                <li>
                                    <img src={require('../../assets/images/frame2.png')} />
                                    <h3>1 in 8</h3>
                                    <p>People are living in obesity. And over 800 million adults are living with chronic diseases</p>
                                </li>
                                <li>
                                    <img src={require('../../assets/images/frame2.png')} />
                                    <h3>45%</h3>
                                    <p>People globally are suffering with an ongoing mental health problem, with only 4% of them getting access to the treatment they need.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className='story-section benefits-section top bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        Subscription Benefits
                                    </h3>
                                    <p className='paragraph mt-5'>
                                        The Subscription with the app can lead your team to be extremely positive. They would connect with you more, as they would understand that you care for them, their health & wellbeing. This can lead to reduced absenteeism and better employee retention.
                                    </p>
                                    <p className='paragraph'>We empower individuals with principles of balance and well-being to improve their overall health.</p>
                                    <p className='paragraph'>Explore the goodness of ayurveda and experience the change.</p>
                                    <p className='paragraph'>
                                        Our platform is forever evolving, new wellness content, podcasts and live sessions are added monthly and new experts join us quarterly. Our contents are based around customer feedback, so we are happy to work with you on any specific requirements you may have.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7'>
                            <div className='right-section right_section_new_n right_section_with_icon'>
                                <ul>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Wellness-Exercises.png')} alt='Wellness-Exercises' /></div><p>1000+ Wellness Exercises</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Mood-created-music.png')} alt='Mood-created-music' /></div><p>500+ Mood created music</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Daily-Quotes.png')} alt='Daily-Quotes' /></div><p>800+ Daily Quotes </p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Southing-Sounds.png')} alt='Southing-Sounds' /></div><p>100+ Southing Sounds</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Podcasts-with-Experts.png')} alt='Podcasts-with-Experts' /></div><p>100+ Interactive Podcasts with Experts</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Meditations-&-Breath.png')} alt='Meditations-&-Breath' /></div><p>Meditations & Breath exercises</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Kids-wellness.png')} alt='Kids-wellness' /></div><p>800+ Kids wellness content</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Recipes-&-Nutritional-advice.png')} alt='Recipes-&-Nutritional-advice' /></div><p>800+ Healthy Recipes & Nutritional advice</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Astrological-wellness.png')} alt='Astrological-wellness' /></div><p>600+ Astrological wellness content</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Psychometrics-tests.png')} alt='Psychometrics-tests' /></div><p>25+ Psychometrics tests </p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Gratitude-Journal.png')} alt='Gratitude-Journal' /></div><p>Gratitude Journal</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/consultation-with-our-experts.png')} alt='consultation-with-our-experts' /></div><p>1-1 consultation with our experts</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/community-Updates.png')} alt='community-Updates' /></div><p>Exclusive community Updates</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/live-session.png')} alt='live-session' /></div><p>Premium Pass to live session</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/Become-a-Podcaster.png')} alt='Become-a-Podcaster' /></div><p>Become a Podcaster and share your story</p></li>
                                    <li><div className='img_icon_box'><img src={require('../../assets/images/corporate/ayurvedic-living.png')} alt='ayurvedic-living' /></div><p>Unleash the Ayurvedic Living for longer and healthier life.</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='story-section benefits-section benefits-section-two top bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>

                        <div className='col-lg-5'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        Optional Services Available
                                    </h3>
                                    <p className='paragraph mt-5'>
                                        Whether you want to offer one on one support to your team or need help in navigating a tough situation, we can provide online support, personalized for you, delivered by the experts.
                                    </p>
                                    <p className='paragraph'>
                                        At the Beyond Lifestyle our idea is to Quiet the noise, focus on the present, and nurture a sense of inner peace. One needs to  stay grounded, reduce stress, and improve our emotional and mental wellness. In a time where we're always ‘on’, mindfulness teaches us the value of being ‘present’, creating space for self-care and emotional resilience.
                                        We also offer optional offsite experiences to complement our app in addition to a few online sessions as well to follow up.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className='col-lg-7'>
                            <div className='right-section right_section_new_n'>
                                {/* <h4>- 1000+ Wellness Exercises</h4> */}
                                <ul>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Wellness Conversations with a panel of our experts</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Multiple Genres ticked in one app</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>One on One Session with Experts </p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Group Exercise Classes</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Nutrition Workshops/ Sessions</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Built Resiliance Workshops</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Time Efficient Tools for Busy Teams</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Mindfulness path made simple</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Mental Wellness Drives</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Mindfulness Path Driven Sessions</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>24*7 Support for your wellness journey</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Daily Micro-Actions for Big Change</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Progress You Can Feel & See</p></li>
                                    <li><div className='icon_box'><i class="fa-solid fa-check"></i></div><p>Ayurvedic Expert Led Lifestyle Sessions</p></li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-12 mt-5 pt-3'>
                            <div className='dialogue_box'>
                                <Link to='/contact' className='common_btn'>Contact Us <i class="fa-solid fa-arrow-right"></i></Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className='get-started-section bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        Get Started Today
                                    </h3>
                                </div>
                                <strong>Personalized, multi-faceted support that’s<br /> always practical and deeply engaging</strong>
                                <p className='paragraph'>We would like all your employees to love The Beyond Lifestyle App and enjoy using it.
                                    That’s the reason we work closely with you to increase employee engagement and retention.</p>
                                <ul className='get-list'>
                                    <li>⦿ Pre- Launch Activity Hosted by the Founder of the App for a Great Connect </li>
                                    <li>⦿ 15 Days Post Follow Up</li>
                                    <li>⦿ Monthly Review meetings on the performance and engagement.</li>
                                    <li>⦿ Quarterly News letter for all.</li>
                                </ul>
                                <ul className='get-circle-box-1 get-circle-box-two'>
                                    <li>
                                        <div className='get-circle-box'>
                                            <h5><strong>65%</strong> Engagement Rate across the Employees</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='get-circle-box'>
                                            <h5>On an Average a person uses the app <strong>18</strong> times per week.</h5>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='get-circle-box'>
                                            <h5>A typical user is noticed to increase its usage by <strong>36%</strong> in <strong>12</strong> weeks</h5>
                                        </div>
                                    </li>
                                </ul>
                                <Link to='/contact' className='common_btn'>Contact Us <i class="fa-solid fa-arrow-right"></i></Link>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='right-section right_section_new_n'>
                                <div className='right-section-img'>
                                    <img src={require('../../assets/images/600x800-1.jpg')} alt='' />
                                </div>
                            </div>
                        </div>
                        <div className='ab-child-box mt-5'>
                            <p className='paragraph'>With The Beyond Lifestyle You are not just Building a Great Team, You are Changing Their Lives and Giving it a Must Needed Hollistic Wellness Boost!</p>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}
